import React from "react";
import { Skeleton } from "stories/Admin";

const PrayerTimesSkeleton: React.FC = () => (
  <div
    aria-busy="true"
    aria-label="Henter bønnetider"
    style={{ display: "flex", flexDirection: "column", gap: 18 }}
  >
    {Array.from({ length: 8 }, (_, i) => (
      <div
        key={i}
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(9, minmax(0, 1fr))",
          gap: 24,
        }}
      >
        {Array.from({ length: 9 }, (_, j) => (
          <Skeleton key={j} height={16} width={j === 0 ? 60 : 44} />
        ))}
      </div>
    ))}
  </div>
);

export default PrayerTimesSkeleton;
